interface Account {
  id: string;
  name: string;
}

export enum PromptGroupKind {
  GENERAL = 'general',
  CRIMINAL = 'criminal',
}

export enum PromptItemKind {
  FILE = 'file',
  TEXT = 'text',
}

export interface PromptGroup {
  id: string;
  account: Account;
  enabled: boolean;
  kind: PromptGroupKind;
  items: PromptItem[];
}

export interface PromptItem {
  id: string;
  kind: PromptItemKind;
  required: boolean;
  translations: Translation[];
}

export interface Translation {
  language: string;
  title: string;
  description: string;
}
